import { TranslationMap } from '@trimble-gcs/i18n-types';

export function clipAndSaveTranslations() {
  return {
    title: {
      text: $localize`:@@clipAndSave.title:Clip and Save`,
      desc:
        'Title of the panel that exports the currently displayed scans, clipped ' +
        'to the active 3D clip box, as a LAZ file. The user receives an email ' +
        'with a download link when the export is ready. Kept short so it fits ' +
        'inside the narrow side panel header.',
    },
    description: {
      text: $localize`:@@clipAndSave.description:The selected scans will be clipped to the active 3D clip box. You will receive an email with a download link when the LAZ file is ready.`,
      desc:
        'Short explanation shown at the top of the Clip and Save panel so the ' +
        'user understands what is about to happen.',
    },
    descriptionMap: {
      text: $localize`:@@clipAndSave.descriptionMap:Scans within the map clip region will be exported. You will receive an email with a download link when the LAZ file is ready.`,
      desc:
        'Short explanation shown at the top of the Clip and Save panel when the ' +
        'clip region was drawn on the 2D map.',
    },
    crsMismatchWarning: {
      text: $localize`:@@clipAndSave.crsMismatchWarning:Selected scans use different coordinate systems. The export may not align as expected.`,
      desc:
        'Warning shown in the Clip and Save panel when the scans to export were ' +
        'geolocated with different coordinate reference systems.',
    },
    name: {
      label: {
        text: $localize`:@@clipAndSave.name.label:Name`,
        desc: 'Label for the name input field in the Clip and Save panel.',
      },
      placeholder: {
        text: $localize`:@@clipAndSave.name.placeholder:Enter a name for the LAZ file`,
        desc: 'Placeholder for the name input field in the Clip and Save panel.',
      },
    },
    submit: {
      text: $localize`:@@clipAndSave.submit:Clip and Save`,
      desc: 'Submit button text in the Clip and Save panel.',
    },
    cancel: {
      text: $localize`:@@clipAndSave.cancel:Cancel`,
      desc: 'Cancel button text in the Clip and Save panel.',
    },
    close: {
      text: $localize`:@@clipAndSave.close:Close`,
      desc:
        'Close button text in the Clip and Save panel after the export has been ' +
        'started successfully. Replaces Cancel so the user can dismiss the ' +
        'success message.',
    },
    submitError: {
      text: $localize`:@@clipAndSave.submitError:Could not start the export. Please try again.`,
      desc: 'Error message shown when the Clip and Save submission fails.',
    },
    submitSuccess: {
      text: $localize`:@@clipAndSave.submitSuccess:Export started.`,
      desc:
        'Success message shown in the Clip and Save panel after the export job has ' +
        'been started. Kept short so it fits the narrow panel modus-alert, matching ' +
        'the import dialog completed message pattern.',
    },
  } satisfies TranslationMap;
}
